import { useQuery } from "@tanstack/react-query";

import { useAppSelector } from "Hooks/useRedux";

import Api from "Api";

export default function useTrafficPath() {
  const { visible } = useAppSelector((state) => state.trafficPath);
  const { date } = useAppSelector((state) => state.filters);

  const statusQuery = () => {
    return "status=enable";
  };
  const nameQuery = () => {
    return "type=car";
  };

  const dataForPost = {
    ScenarioUniqueId: "eb801397-9187-4b83-8975-9d563dab4aad",
    ServiceUniqueId: "888b4dc0-6489-4fe5-8fa1-3eed2c591233",
    IncludeNonServiceBranches: false,
    Parameters: {
      "101d0479-1eae-4758-ae70-101e68d120d9": ["subway"],
    },
    InputTables: [],
    OutputColumns: [],
  };
  const { data, refetch, isLoading, isFetching } = useQuery({
    queryKey: [visible],
    queryFn: () => {
      return Api.sPost(
        "https://report2.ardban.ir:7072/https://report2.ardban.ir:8080/gateway/MSSE.DIA/api/ScenarioServiceCallApi/ShortTimeServiceExecute",
        dataForPost
      ).then((res) => {
        console.log(res.data.Rows, "jnkjnmjm");
        return res.data.Rows;
      });
    },
    enabled: visible,
  });

  return { data, isLoading, refetch, isFetching };
}
